<template>
  <div>实验考核记录</div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang='less' scoped>
</style>